/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Channel_EmailInputs */

const de_notifications_preferences_channel_email = /** @type {(inputs: Notifications_Preferences_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/** @type {(inputs: Notifications_Preferences_Channel_EmailInputs) => LocalizedString} */
const en_notifications_preferences_channel_email = de_notifications_preferences_channel_email;

/**

* @param {Notifications_Preferences_Channel_EmailInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_channel_email = /** @type {((inputs?: Notifications_Preferences_Channel_EmailInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Channel_EmailInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_channel_email(inputs)
	return en_notifications_preferences_channel_email(inputs)
});